import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../components/Modal/Modal'

interface LinkIntegrationModalProps {
  show: boolean
  onHide: () => void
}

export const LinkPhoneNumberModal: React.FC<LinkIntegrationModalProps> = ({ show, onHide }) => {
  const navigate = useNavigate()

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<h4>Link Your Phone Number</h4>}
      body={<div>To switch to Phone Meeting, you need to connect your phone number to Zocks first.</div>}
      showFooterActions={true}
      footerPrimaryActionTitle='Go to Integrations'
      onFooterPrimaryAction={() => navigate('/account/integration-settings/phone')}
    />
  )
}

export const LinkRingCentralModal: React.FC<LinkIntegrationModalProps> = ({ show, onHide }) => {
  const navigate = useNavigate()

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<h4>Connect your RingCentral account</h4>}
      body={<div>To switch to RingCentral Meeting, you need to connect your RingCentral account to Zocks first.</div>}
      showFooterActions={true}
      footerPrimaryActionTitle='Go to Integrations'
      onFooterPrimaryAction={() => navigate('/account/integration-settings/ringcentral')}
    />
  )
}

interface LinkGotoModalProps {
  onHide: () => void
}

export const LinkGotoModal: React.FC<LinkGotoModalProps> = ({ onHide }) => {
  const navigate = useNavigate()

  return (
    <Modal
      show
      onHide={onHide}
      header={<h4>Connect your GoTo account</h4>}
      body={<div>To switch to GoTo Meeting, you need to connect your GoTo account to Zocks first.</div>}
      showFooterActions={true}
      footerPrimaryActionTitle='Go to Integrations'
      onFooterPrimaryAction={() => navigate('/account/profile-settings/integrations')}
    />
  )
}
